<template>
  <div class="ibox float-e-margins" :class="{ 'no-padding': noPadding }">
    <div class="ibox-title" :class="{ selected: selected }">
      <slot name="title"></slot>
    </div>
    <div class="ibox-content ibox-heading" v-if="$slots.heading">
      <slot name="heading"></slot>
    </div>
    <div class="ibox-content" :class="{ fixed: fixed }" :style="contentStyle">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'IBox',
  components: {
    ContentLoader,
  },
  props: {
    noPadding: false,
    selected: true,
    contentHeight: 0,
    fixed: false,
  },
  computed: {
    contentStyle() {
      if (!this.contentHeight) {
        return '';
      }

      return `height: ${this.contentHeight}px`;
    },
  },
};
</script>

<style type="text/scss" scoped>
.selected {
  border-top: 2px solid #ee2465;
}

.fixed {
  overflow-y: scroll;
  height: 600px;
}

.ibox {
  border: 1px solid #e9e9e9;
  box-shadow: 2px 2px 7px 0 #ddd;
  background-color: #ffffff;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// IBox.vue?7063b658